export default __webpack_public_path__ + "d524d38551d9fd9d1ac6eb84e04c5922.gif";